import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { envelopeSchema } from '../lib/schemas';

const projectReportSettingSchema = z.object({
  id: z.string(),
  project_id: z.string(),
  include_travel_time: z.boolean(),
  show_isolated_summary: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type ProjectReportSetting = z.infer<typeof projectReportSettingSchema>;

export const projectReportSettingService = {
  async getSetting(projectNumber: string): Promise<ProjectReportSetting> {
    const result = await apiClient.get(apiUrl.projectReportSettings(projectNumber), {
      validate: envelopeSchema('project_report_setting', projectReportSettingSchema),
      deduplicate: true,
      context: 'getProjectReportSetting',
    });
    return result.project_report_setting;
  },

  async updateSetting(
    projectNumber: string,
    includeTravelTime?: boolean,
    showIsolatedSummary?: boolean
  ): Promise<ProjectReportSetting> {
    const body: any = {};
    if (includeTravelTime !== undefined) {
      body.include_travel_time = includeTravelTime;
    }
    if (showIsolatedSummary !== undefined) {
      body.show_isolated_summary = showIsolatedSummary;
    }
    const result = await apiClient.put(apiUrl.projectReportSettings(projectNumber), body, {
      validate: envelopeSchema('project_report_setting', projectReportSettingSchema),
      context: 'updateProjectReportSetting',
    });
    return result.project_report_setting;
  },
};
